import { date, formatting } from '~/support/utils';

const daysLeft = (endDate) => {
  return Math.max(formatting.daysBetween(date.today(), endDate), 0);
};

export default { daysLeft };
